// Page Seven slides
import Swiper, { Navigation, Pagination } from "swiper";
Swiper.use([ Navigation, Pagination ]);

var slideTitles = [
	"You chose to bring restoration",
	"Survivors lead the fight for justice",
	"Meet Pachaiyammal",
	"Meet David",
	"Meet Victoria"
]

// Maps
var sevenCarousel = new Swiper('#page-seven .jsCarousel',
{
	spaceBetween: 30,
	// freeMode: true,
	// freeModeSticky: true,
	centeredSlides: true,
	grabCursor: true,
	pagination: {
		el: '.swiper-pagination',
		clickable: true,
		renderBullet: function (index, className)
		{
			return '<button type="button" class="' + className + '"><span class="visuallyhidden">' + slideTitles[index] + '</span></button>';
		},
	},
	navigation: {
		prevEl: '.swiper-button-prev',
		nextEl: '.swiper-button-next'
	}
});